import { call, put } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import { AssignTree, PAssignTreeType } from 'src/types'
import { ClientNotifyCatch } from 'src/config/bugsnag'
import api from 'src/services/api'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'
import i18n from 'src/config/i18n'

import * as Actions from './actions'

type TreesResponse = {
  trees: AssignTree[]
}
export function* getTree() {
  try {
    const response: ApiResponse<TreesResponse> = yield call(api.get, `/trees`)

    if (response.ok) {
      /**
       * @todo
       * this filter fixes an api failure
       * apparently user nodes shouldn't be displayed
       */
      const trees =
        response.data?.trees?.filter(
          tree => tree.p_assign_tree_type !== PAssignTreeType.USER
        ) || []
      yield put(Actions.getTreeSuccess(trees))
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.getTreeFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga getTree', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.getTreeFailure(message))
  }
}
